export default {
  "fr": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Changez responsable"
      },
      "attributes": {
        "introduction": "Introduction",
        "responsible": "Responsable",
        "title": "Titre"
      },
      "labels": {
        "ask_question": "Quel genre de question voulez-vous poser?",
        "editInternalTitle": "Modifier le titre interne?",
        "explainerNPSPart1": "Le Score Net du Promoteur est un indice compris entre -100 et 100 qui mesure la volonté des clients de recommander votre société ou vos projets à d'autres.",
        "explainerOpinionScale": "Mesurez l'accord de vos clients avec un énoncé général.",
        "moreInfo": "Plus d'informations",
        "nps": "Score Net du Promoteur",
        "npsQuestion": "NPS",
        "open_ended": "Echelle d'opinion",
        "preview": "Example",
        "satisfaction": "Satisfaction",
        "tab_summary": "Sommaire",
        "tab_units": "Unités",
        "yes_no": "Oui-Non"
      },
      "navigation": {
        "backToSurveyTypes": "Retour aux enquêtes"
      },
      "toasts": {
        "bulk_delete": "Enquête supprimée avec succès | Enquêtes supprimées avec succès",
        "update": "Enquête mis à jour avec succès"
      },
      "validation": {
        "need_name": "Titre requis",
        "selectSurveyType": "Sélectionnez au moins 1 enquête"
      }
    }
  }
}